import type { Infer } from 'superstruct';
import {
	array,
	boolean,
	defaulted,
	number,
	object,
	optional,
	partial,
	record,
	string,
} from 'superstruct';

import {
	parsableInteger,
	stringDate,
	userString,
} from '@adflow/shared/util-superstruct';

import {
	AddGoogleAdsAccountDto,
	ViewGoogleAdsAccountDto,
} from './google-ads-account.dto';
import {
	AddGoogleAdsCampaignTemplateDto,
	ViewGoogleAdsCampaignTemplateDto,
} from './google-ads-campaign.dto';

export const GoogleAdsSavedAudienceDto = record(string(), string());

export const GoogleAdsSavedMerchantCenterDto = record(string(), string());

export const GoogleAdsSavedPromotionalAssetsDto = record(
	string(),
	array(number())
);

export const GoogleAdsSavedGroupPromotionalAssetsDto = record(
	string(),
	record(string(), array(number()))
);

export type GoogleAdsSavedAudienceDto = Infer<typeof GoogleAdsSavedAudienceDto>;
export type GoogleAdsSavedMerchantCenterDto = Infer<
	typeof GoogleAdsSavedMerchantCenterDto
>;
export type GoogleAdsSavedPromotionalAssetsDto = Infer<
	typeof GoogleAdsSavedPromotionalAssetsDto
>;
export type GoogleAdsSavedGroupPromotionalAssetsDto = Infer<
	typeof GoogleAdsSavedGroupPromotionalAssetsDto
>;

export const ViewGoogleAdsTemplateDto = object({
	id: number(),
	name: string(),
	createdById: number(),

	createdAt: stringDate(),
	updatedAt: stringDate(),
	archived: boolean(),
	salesforceImport: boolean(),

	savedAudiences: optional(GoogleAdsSavedAudienceDto),
	savedMerchantCenters: optional(GoogleAdsSavedMerchantCenterDto),
	savedPromotionalAssets: optional(GoogleAdsSavedPromotionalAssetsDto),
	savedGroupPromotionalAssets: optional(
		GoogleAdsSavedGroupPromotionalAssetsDto
	),
	adAccounts: optional(array(ViewGoogleAdsAccountDto)),
	campaignTemplates: optional(array(ViewGoogleAdsCampaignTemplateDto)),
});

export const AddGoogleAdsTemplateDto = object({
	id: optional(parsableInteger()),
	name: userString('validations:Required'),
	archived: defaulted(boolean(), false),

	savedAudiences: optional(GoogleAdsSavedAudienceDto),
	savedMerchantCenters: optional(GoogleAdsSavedMerchantCenterDto),
	savedPromotionalAssets: optional(GoogleAdsSavedPromotionalAssetsDto),
	savedGroupPromotionalAssets: optional(
		GoogleAdsSavedGroupPromotionalAssetsDto
	),

	adAccounts: optional(array(AddGoogleAdsAccountDto)),
	campaignTemplates: optional(array(AddGoogleAdsCampaignTemplateDto)),
});

export const EditGoogleAdsTemplateDto = partial(AddGoogleAdsTemplateDto);

export type ViewGoogleAdsTemplateDto = Infer<typeof ViewGoogleAdsTemplateDto>;
export type AddGoogleAdsTemplateDto = Infer<typeof AddGoogleAdsTemplateDto>;
export type EditGoogleAdsTemplateDto = Infer<typeof EditGoogleAdsTemplateDto>;
